import { HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import _ from 'lodash';
import { Observable } from 'rxjs';
import { TokenSaverService } from 'src/app/view-model/services/token-saver.service';

@Injectable({
  providedIn: 'root'
})
export class JwtInterceptor implements HttpInterceptor {

  constructor(private tokenService: TokenSaverService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (_.includes(req.url, 'bff-checkout/api/checkout/auth')) {
      const newHeaders = req.headers.delete('Anonymous');
      const newRequest = req.clone({ headers: newHeaders });
      return next.handle(newRequest);
    } else if (_.includes(req.url, 'bff-checkout/api/checkout/login-campania')) {
      const newHeaders = req.headers.delete('Anonymous');
      const newRequest = req.clone({ headers: newHeaders });
      return next.handle(newRequest); 
    } else if (_.includes(req.url, 'bff-checkout/api/marketplace/')) {
      const newHeaders = new HttpHeaders({
        'Content-Type': 'application/json'
      });
      newHeaders.delete('Anonymous');
      const newRequest = req.clone({ headers: newHeaders });
      return next.handle(newRequest);
    } else if (_.includes(req.url, 'bff-checkout/api/checkout/notificacion-correo')) {
      return next.handle(req);
    } else if (_.includes(req.url, 'bff-checkout/api/checkout/producto/valida-pago-proactivo')) {
      return next.handle(req);
    } else {
      const token = this.tokenService.getToken();
      const headers = new HttpHeaders({
        Authorization : token,
        'Content-Type': 'application/json'
      });

      req = req.clone({ headers });
      return next.handle(req);
    }
  }
}
